import React, { useRef } from 'react';
import { Upload } from 'lucide-react';

interface FilesUploadButtonProps {
  onFilesSelect: (files: FileList) => void | Promise<void>;
  accept?: string;
  multiple?: boolean;
  disabled?: boolean;
  className?: string;
  title?: string;
  subtitle?: string;
}

export const FilesUploadButton: React.FC<FilesUploadButtonProps> = ({
  onFilesSelect,
  accept = '.pdf,.ppt,.doc,.docx,.xlsx,.png,.jpeg,.jpg',
  multiple = false,
  disabled = false,
  className = '',
  title = 'Drag and drop files here',
  subtitle = 'Supported: PDF, PPT, DOC, DOCX, XLSX, PNG, JPEG',
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFiles = (files: FileList | null) => {
    if (!files || disabled) return;
    void onFilesSelect(files);
  };

  return (
    <>
      <input
        ref={fileInputRef}
        type="file"
        hidden
        accept={accept}
        multiple={multiple}
        onChange={(e) => handleFiles(e.target.files)}
      />

      <button
        type="button"
        disabled={disabled}
        onClick={() => fileInputRef.current?.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault();
          handleFiles(e.dataTransfer.files);
        }}
        className={`min-h-[170px] rounded-xl border-2 border-dashed border-muted-foreground/30 
        hover:border-primary/40 bg-background/70 transition-colors px-4 py-5 text-center
        disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
      >
        <div className="flex h-full flex-col items-center justify-center gap-2 text-muted-foreground">
          <Upload className="h-5 w-5" />
          <p className="font-medium">{title}</p>
          <p className="text-sm">{subtitle}</p>
        </div>
      </button>
    </>
  );
};
